import { render, staticRenderFns } from "./AcoesRevogar.vue?vue&type=template&id=61dacdcb&scoped=true"
import script from "./AcoesRevogar.vue?vue&type=script&lang=js"
export * from "./AcoesRevogar.vue?vue&type=script&lang=js"
import style0 from "./AcoesRevogar.vue?vue&type=style&index=0&id=61dacdcb&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dacdcb",
  null
  
)

export default component.exports